export default __webpack_public_path__ + "static/media/yellow-brakes.0e8b6ac2.svg";